import { Group, Code, ScrollArea, rem, Image } from '@mantine/core';
import {
  IconNotes,
  IconCalendarStats,
  IconGauge,
  IconPresentationAnalytics,
  IconFileAnalytics,
  IconAdjustments,
  IconLock,
  IconBuildingWarehouse,
  Icon3dCubeSphere,
} from '@tabler/icons-react';
import { UserButton } from '../../../../assets/uicomponents/UserButton/UserButton.jsx';
import { LinksGroup } from '../../../../assets/uicomponents/NavbarLinksGroup/NavbarLinksGroup.jsx';
import classes from './NavbarNested.module.css';
import { Link } from 'react-router-dom';
import { useAppContext } from '../../../context/AppContext.jsx';

// `permission` matches the screen keys in src/constants/screens.js - items
// with no `permission` are baseline and shown to every admin-side account.
const mockdata = [
  { label: 'Dashboard', icon: IconGauge, links:'/admin/dashboard'  },
  {
    label: 'Patients',
    icon: IconNotes,
    initiallyOpened: false,
    links: '/admin/patients',
    permission: 'patients',
  },
  {
    label: 'Slots',
    icon: IconCalendarStats,
    permission: 'slots',
    links: [
      { label: 'View Slots', link: '/admin/slots/view' },
      { label: 'Open Slots', link: '/admin/slots/open' },
      // { label: 'Edit Slots', link: '/admin/slots/edit' },+
    ],
  },
  { label: 'Appointments', icon: IconPresentationAnalytics,links:'/admin/appointments', permission: 'appointments' },
  { label: 'Follow Ups', icon: IconPresentationAnalytics,links:'/admin/followups', permission: 'followups' },
  { label: 'Consultations', icon: IconPresentationAnalytics,links:'/admin/consultations', permission: 'consultations' },
  { label: 'Emergency Form', icon: IconPresentationAnalytics,links:'/admin/form', permission: 'emergencyForm' },
  { label: 'Dosages', icon: IconFileAnalytics,links:'/admin/dosages', permission: 'dosages' },
  { label: 'General Instructions', icon: IconFileAnalytics,links:'/admin/instructions', permission: 'instructions' },
  { label: 'Consultation Centres', icon: IconBuildingWarehouse,links:'/admin/centres', permission: 'centres' },
  { label: 'Dealers', icon: IconBuildingWarehouse,links:'/admin/dealers', permission: 'dealers' },
  { label: 'Dealer Analytics', icon: IconPresentationAnalytics,links:'/admin/dealer-analytics', permission: 'dealerAnalytics' },
  { label: 'Video Upload', icon: IconBuildingWarehouse,links:'/admin/videoUpload', permission: 'videoUpload' },
  { label: 'Orders', icon: IconBuildingWarehouse,links:'/admin/orders', permission: 'orders' },
  { label: 'MHS Products', icon: IconBuildingWarehouse,links:'/admin/products', permission: 'products' },
  { label: 'Manage Users', icon: IconLock,links:'/admin/staff', permission: 'manageUsers' },
  { label: 'Profile', icon: IconAdjustments,links:'/admin/profile' },
  { label: 'Notification', icon: IconAdjustments,links:'/admin/notification' },
];

const dealerData = [
  { label: 'Dashboard', icon: IconGauge, links:'/dealer/dashboard'  },
  { label: 'My Analytics', icon: IconPresentationAnalytics, links:'/dealer/dashboard' },
  {label: 'Place Order', icon: IconGauge, links:'/dealer/form'  },
  { label: 'MHS Products', icon: Icon3dCubeSphere,links:'/dealer/products' },
  {label: 'Change Password', icon: IconAdjustments,links:'/dealer/change-password' },
  { label: 'Communication', icon: IconAdjustments,links:'/dealer/communication' },
]

export function NavbarNested() {
  const {user} = useAppContext();
  console.log("user in vanigatios");
  console.log(user);
  const links = user.role === 'admin' ? mockdata.map((item) => <LinksGroup {...item} key={item.label} />) : (
    user?.role === 'staff' ? mockdata
      .filter((item) => !item.permission || user.permissions?.includes(item.permission))
      .map((item) => <LinksGroup {...item} key={item.label} />) : (
      user?.role === 'dealer' && dealerData.map((item) => <LinksGroup {...item} key={item.label} />)
    )
  );

  return (
    <nav className={`${classes.navbar} bg-mhs-navbar h-screen w-1/6`}>
      <div className={classes.header}>
        <Group justify="space-between">
          <Image src="/logo.png" alt="mhs logo" width={40} height={10} />
        </Group>
      </div>

      <ScrollArea className={classes.links}>
        <div className={`${classes.linksInner} pt-1`}>{links}</div>
      </ScrollArea>

      <div className={`${classes.footer}`}>
        <UserButton />
      </div>
    </nav>
  );
}